import React, { useEffect, useMemo, useRef } from 'react';

import { debounce, mergeObjects } from 'codekit';

import * as C from './ScrambleText.utils';

interface ComponentProps {
	chars?: string;
	phrases: string[];
	delay?: number;
}

const defaultProps: Required<ComponentProps> = {
	chars: '!<>-_\\/[]{}—=+*^?#________',
	phrases: [],
	delay: 2500,
};

function ScrambleText(baseProps: ComponentProps) {
	// Props merging
	const props = useMemo(
		() => mergeObjects(defaultProps, baseProps),
		[baseProps]
	);

	// Refs
	const ref = useRef<HTMLSpanElement>(null);

	// Effects
	useEffect(() => {
		const element = ref.current;
		if (!element) return;

		const fx = new C.ScrambleTextEffect(element, props.chars);
		let counter = 0;
		let timeout: NodeJS.Timeout;

		const next = () => {
			fx.setText(props.phrases[counter]).then(() => {
				timeout = setTimeout(next, props.delay);
			});
			counter = (counter + 1) % props.phrases.length;
		};

		debounce(next, 1000);

		return () => clearTimeout(timeout);
	}, [props]);

	return <span className="scramble-text" ref={ref} />;
}

export default ScrambleText;
